import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from, until } from '@helpers/media';
import { contentStyles, paragraphLarge } from '@helpers/typography';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  overflow: hidden;

  ${SectionWrapperStyles.Inner} {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    gap: 16px;
  }
`;
const Table = styled.div `
  grid-column: span 12;
  
  border: ${fluid(1, 2)} solid ${brand.blue.navy};
  border-radius: ${fluid(10, 20)} ${fluid(10, 20)} ${fluid(10, 20)} 0;
  overflow: hidden;

  @media ${from(Device.Tablet)} {
    grid-column: 2 / span 10;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }
`;
const TableRow = styled(m.div) `  
  border-bottom: ${fluid(1, 2)} solid ${brand.blue.navy};

  @media ${from(Device.Tablet)} {
    grid-column: span 12;
    display: grid;
    grid-template-columns: subgrid;
  }

  &:last-child {
    border-bottom: none;
  }
`;
const Title = styled.button `
  ${ButtonReset};
  ${paragraphLarge};
  ${fonts.proximaNova.bold};
  margin: 0;
  display: flex;
  align-items: flex-start;
  text-align: left;
  justify-content: space-between;
  gap: 8px;
  grid-column: 1 / span 4;
  padding: 16px 40px 16px 16px;
  background-color: ${brand.global.beige};
  width: 100%;
  position: relative;

  @media ${from(Device.Tablet)} {
    cursor: initial;
    justify-content: flex-start;
    gap: 0;
    padding: ${fluid(16, 24)} ;
  }

  &.focus-ring {
    @media ${until(Device.Tablet)} {
      outline: auto;
      outline-offset: -5px;
      outline-width: 2px;
      outline-color: var(--textColour, var(--primaryColour));
    }
  }

  &[data-show='true'] {
    svg {
      transform: rotate(180deg);
    }
  }

  svg {
    ${transition('transform', 0.25)};
    position: absolute;
    right: 16px;
    top: 20px;
    width: 18px;
    height: 18px;

    @media ${from(Device.Tablet)} {
      display: none;
    }
  }
`;
const ContentWrapper = styled(m.div) `
  overflow: hidden;
  grid-column: 5 / span 7;

  @media ${from(Device.Tablet)} {
    border-left: 2px solid ${brand.blue.navy};
  }
`;
const Content = styled.div `
  ${contentStyles};
  --listColour: ${brand.blue.navy};
  
  padding: ${fluid(16, 24)};

  ul {
    ${fonts.proximaNova.regular};

    li {
      margin-bottom: 0;
    }
  }

  
`;
const LinkArea = styled.div `
  grid-column: 1 / span 12;
  padding: 0;
  display: flex;
  justify-content: flex-end;

  @media ${from(Device.Tablet)} {
    grid-column: 2 / span 10;
  }
`;
const ProductDetailstyles = {
    Container,
    Content,
    ContentWrapper,
    LinkArea,
    Table,
    TableRow,
    Title,
};
export default ProductDetailstyles;
